import * as S from './dropdownMenu.styles';

export const { DropdownMenu } = S;
